import { createContext, useContext, useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import getDataStorage from '@shared/utils/auth/getDataStorage';
import clearDataStorage from '@shared/utils/auth/clearDataStorage';
import useConnection from '@shared/hooks/useConnetions/useConnection';
import TigerSQLite from '@shared/utils/mobile/tigerSqlite';

const AuthContext = createContext();

const SESION_OFFLINE_CAMPOS = [
    { name: 'id', type: 'INTEGER PRIMARY KEY' },
    { name: 'logged', type: 'TEXT' },
    { name: 'updated_at', type: 'TEXT' },
];

async function guardarSesionOffline() {
    try {
        await TigerSQLite.modifyTable('delete', 'sesion_offline').catch(() => {});
        await TigerSQLite.modifyTable('create', 'sesion_offline', SESION_OFFLINE_CAMPOS);
        await TigerSQLite.insert('sesion_offline', {
            logged: 'true',
            updated_at: new Date().toISOString(),
        });
    } catch (e) {
        console.warn('[sesion_offline] Error guardando:', e?.message);
    }
}

async function borrarSesionOffline() {
    try {
        await TigerSQLite.modifyTable('delete', 'sesion_offline').catch(() => {});
    } catch (e) {
        console.warn('[sesion_offline] Error borrando:', e?.message);
    }
}

export const AuthProvider = ({ children }) => {
    const [userData, setUserData] = useState(getDataStorage() ?? null);
    const [loadingAuth, setLoadingAuth] = useState(true);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    // const location = useLocation();
    const connection = useConnection();

    const isLogged = async () => {
        const dataUser = getDataStorage();
        if (!dataUser) return false;
        setUserData(dataUser);
        guardarSesionOffline();
        return true;
    };

    const logOut = async () => {
        try {
            await connection({
                url: `/auth/api/v1/auth/local/logout`,
                api: 'NITRO4',
                method: 'GET',
            });
            clearDataStorage();
            borrarSesionOffline();
            setUserData(null);
            navigate('/login');
        } catch (error) {
            console.error(error);
        };
    };

    const handleSetUserData = (data) => {
        if (data) {
            setUserData(data);
            guardarSesionOffline();
        }
    };

    useEffect(() => {
        setLoading(true);
        isLogged().then((logged) => {
            setLoadingAuth(false);
            // if (!logged) {
            //     navigate('/login');
            // };
        });
        setLoading(false);
    }, []);

    return (
        <AuthContext.Provider
            value={{ userData, loadingAuth, loading, logOut, isLogged, handleSetUserData }}
        >
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
